import { create } from 'zustand'

const storeSettings = (set) => ({
    currentRoles: '',
    setCurrentRoles: (_roles) => { set({ currentRoles: _roles }) },
    allowedApps: [],
    setAllowedApps: (apps) => { set({ allowedApps: apps }) },
});

const useStoreCurrentUserRoles = create(storeSettings);

export default useStoreCurrentUserRoles;